import type { OrdenServicioConRelaciones } from '@/modules/ordenes-servicio/tipos'

/**
 * De una orden de la matriz a lo que la hoja necesita para armarse.
 *
 * Vive aparte porque lo usan los dos sitios que enseñan el mismo documento: el
 * resumen que va dentro de la tarjeta y la hoja entera que se abre encima. Si
 * cada uno armara su fuente, un día enseñarían cosas distintas del mismo
 * documento, que es justo lo que no puede pasar con la plata.
 *
 * Además comparten la misma clave de consulta, así que el segundo no vuelve a
 * pedir nada: abre con lo que el primero ya trajo.
 */
export function fuenteDeLaOrden(orden: OrdenServicioConRelaciones) {
  const cot = orden.cotizacion
  if (!cot) return null

  const numero = cot.numero_cotizacion ?? ''

  return {
    idAsiento: cot.wo_id_asiento,
    cotizacionId: cot.id,
    // El prefijo viaja aparte, así que del número se quita si lo lleva pegado
    // («FEV 2836» → «2836»).
    numero: numero.replace(/^[A-Za-z]+[\s-]*/, ''),
    prefijo: cot.wo?.prefijo ?? numero.replace(/[^A-Za-z]/g, ''),
    fecha: cot.wo?.fecha ?? cot.fecha_cotizacion,
    cliente: orden.cliente?.nombre ?? null,
    clienteDocumento: orden.cliente?.documento ?? null,
    vendedor: cot.wo?.vendedor_nombre ?? null,
    // Mientras la cotización no ha viajado a World Office no hay documento
    // del que leer el vendedor, pero sí el que se escogió al cotizar.
    idVendedor: cot.wo_id_vendedor ?? null,
    direccionObra: orden.direccion ?? null,
    concepto: 'Orden de servicio ' + orden.numero,
  }
}
